import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
  TdDialogService,
} from '@covalent/core';
import { MdSelect } from '@angular/material';

import { TecnicasDiagnosticasService, MasterService, LoginService, } from '../../../../services/';

import { AltaTecnicaDiagnosticaComponent } from './altatecnicasdiagnosticas/altatecnicasdiagnosticas.component';

import { TecnicaDiagnostica } from '../../../../models';

@Component({
  selector: 'qs-tecnicasdiagnosticasdetalle',
  styleUrls: ['./tecnicasdiagnosticasdetalle.component.scss'],
  templateUrl: './tecnicasdiagnosticasdetalle.component.html',
  viewProviders: [TecnicasDiagnosticasService, MasterService],
})

export class TecnicasDiagnosticasDetalleComponent implements AfterViewInit, OnDestroy {

  private sub: any;
  public mode: string;
  public title: string;
  public idPaciente: string;
  public idValoracion: string;

  public tecnicaDiagnostica: TecnicaDiagnostica;
  public tecnicasDiagnosticas: any[] = [];
  public valoraciones: any[];

  public columnsAll: ITdDataTableColumn[] = [
    { name: 'id', label: 'Id', sortable: false, hidden: true },
    { name: 'titulo', label: 'Nombre Técnica', sortable: true, hidden: false },
    { name: 'idPadre', label: 'Técnica', hidden: true },
  ];

  public columns: ITdDataTableColumn[] = this.columnsAll;

  // Datos
  public filteredData: any[] = [];
  public filteredDataTotal: number;

  // Propiedades
  public clickable: boolean = true;
  public selectable: boolean = false;
  public sortable: boolean = true;
  public sortBy: string = 'titulo';
  public sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  public searchTerm: string = '';

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _master: MasterService,
    private _dataTableService: TdDataTableService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef, ) { }

  ngAfterViewInit(): void {
    let id: string = 'idValoracion';
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('tecnicadiagnostica.load');
    this.sub = this._route.params.subscribe((params: any) => {
       this.idValoracion = params[id];
    });
    this._master.obtenerMasterTecnicasDiagnosticas().subscribe((res: any) => {
      this.tecnicasDiagnosticas = res.respuesta.tecnicas;
      this.filteredData = this.tecnicasDiagnosticas;
      this.filteredDataTotal = this.tecnicasDiagnosticas.length;
      this._loadingService.resolve('tecnicadiagnostica.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo técnicas diágnosticas.', 'OK', 6000);
      this._loadingService.resolve('tecnicadiagnostica.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.tecnicasDiagnosticas;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  /**
   * Abre una vista detalle de la consulta
   * @param tecnica
   */
  openDetail(tecnica: any): void {
    let dialogRef: any = this._dialogService.open(AltaTecnicaDiagnosticaComponent, {
      data: tecnica,
      width: '50%',
      role: 'dialog',
    });
    dialogRef.componentInstance.tecnica = tecnica;
    dialogRef.componentInstance.titulo = tecnica.titulo;
    dialogRef.componentInstance.idValoracion = this.idValoracion;
  }

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/tecnicasdiagnosticas/tecnicasdiagnosticasdetalle/tecnicasdiagnosticasdetalle.component.ts